import { render, staticRenderFns } from "./DeadlineTracker.vue?vue&type=template&id=2654f110&"
import script from "./DeadlineTracker.vue?vue&type=script&lang=js&"
export * from "./DeadlineTracker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DeadlineTracker.vue"
export default component.exports